{
    "columns": [
      {
        "header_id": "fileName",
        "header_label": "File Name",
        "jsonpath": "fileName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "createdDate",
        "header_label": "Upload Date",
        "jsonpath": "createdDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "pplId",
        "header_label": "PPL ID",
        "jsonpath": "pplId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "firstName",
        "header_label": "First Name",
        "jsonpath": "firstName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "lastName",
        "header_label": "Last Name",
        "jsonpath": "lastName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },     
      {
        "header_id": "documentType",
        "header_label": "Document Type",
        "jsonpath": "documentType",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [
      {
        "button_id":"file_upload_notification",
        "button_label":"Acknowledge",
        "buttonAction" : "fileUploadNotificationAcknowledge",
        "className": "primary-btn-color"
      }
    ],
    "apiDetails": "fileUploadNotificationList.json",
    "pageName": "fileuploadntfctnlist",
    "orderByColumn": ["createdDate"],
    "orderBy": ["desc"]
  }
  